import React from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';

function AddWholeSaleMenu(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'recommendedItem', headerName: 'Item', width: 200 },
        { field: 'Timeduration', headerName: 'AddOns', width: 200 },
        { field: 'basePrice', headerName: 'Base Price', width: 200 },
        { field: 'VAT', headerName: 'VAT', width: 200 },
        { field: 'TotalPrice', headerName: 'Total Price', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', recommendedItem: 'Chicken cheese burger', Timeduration: "	Chicken,Curry,", basePrice: "1.0", VAT: "1.0", TotalPrice: "2.0" },
        { id: 2, checkbox: '', recommendedItem: 'Chicken cheese burger', Timeduration: "	Chicken,Curry,", basePrice: "1.0", VAT: "1.0", TotalPrice: "2.0" },
    ];
    return (
        <div>
            <div>
                <FilterComponents title={"OK"} isItem={8} />
                <CustomDataGrid columns={columns} dataRows={dataRows} />
            </div>
        </div>
    );
}

export default AddWholeSaleMenu;